const infographics_counter: any = [
  {
    id: 0,
    count: 20,
    title: "Aylıq Gəlir",
  },
  {
    id: 1,
    count: 20,
    title: "Həftəlik Satışlar",
  },
  {
    id: 2,
    count: 321,
    title: "Yeni Müştərilər",
  },
  {
    id: 3,
    count: 82,
    title: "Aktiv İstifadəçilər",
  },
];

export default infographics_counter;
